import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AwsService, HelperService, SwalService } from '__services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { APP_ROUTES } from '~/app/core/routes/app-routes';

@Component({
  selector: 'app-new-phone',
  templateUrl: './new-phone.component.html',
  styleUrls: ['./new-phone.component.scss', '../login/login.component.scss'],
})
export class NewPhoneComponent implements OnInit, OnDestroy {
  isConfirmed = true;
  isLoading = false;
  hide = true;
  confirmForm: FormGroup;
  errorMsg = '';
  successMsg = '';
  user: any;

  private destroy$: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private awsService: AwsService
  ) {
    this.confirmForm = this.fb.group({
      phone: [
        '',
        [Validators.required, Validators.maxLength(12), Validators.minLength(9)],
      ],
    });
    this.awsService.confirmSMS
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          const phoneNumber = this.user.attributes?.phone_number;
          this.confirmForm.controls.phone.setValue(phoneNumber || '');
        } else {
          this.router.navigate([APP_ROUTES.LOGIN]);
        }
      });
  }

  get confirmFormControls() {
    return this.confirmForm.controls;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  sendRequest(): void {
    if (this.confirmForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.awsService.sendCode(this.confirmFormControls.code.value).then(
      (res) => {
        this.isLoading = false;
        this.errorMsg = '';
        this.isConfirmed = false;
        this.confirmForm.reset();
      },
      (err) => {
        this.errorMsg = err.message;
        this.isLoading = false;
        this.isConfirmed = true;
      }
    );
  }

  submitForm(): void {
    if (this.confirmForm.invalid) {
      return;
    }
    this.isLoading = true;
    const phone =
      this.confirmForm.value.phone[0] === '+'
        ? this.confirmForm.value.phone
        : '+' + this.confirmForm.value.phone;
    this.awsService
      .updateUserAttributes(this.user, {
        phone_number: phone,
      })
      .then(
        () => {
          this.isLoading = false;
          this.router.navigate([APP_ROUTES.CONFIRM_SMS]);
        },
        (err) => {
          this.isLoading = false;
          SwalService.error(err?.message || 'Error');
        }
      );
  }

  backToLogin(): void {
    this.router.navigate([APP_ROUTES.LOGIN]);
  }

  getToday(): string {
    return HelperService.getToday();
  }
}
